
<div class="card p-0 bg-semiblack/50 backdrop-blur-sm overflow-hidden">

    <div class="carousel max-h-44 w-full" >
        <div class="splide" #carousel>
        <div class="splide__track">
            <ul class="splide__list">
                @for (img of data.img; track $index) {
                    <li class="splide__slide cursor-pointer">
                      <img [src]="img" [alt]="'Slide image'" class="carousel-image">
                    </li>
                }
            </ul>
        </div>
        </div>
    </div>

</div>